import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { scrollToId } from "@/App";

const ROWS = [
  ["Unbound Document", "A4 · 70 GSM · PER COPY", "₹6"],
  ["Corner Staple Pinning", "A4 · QUICK HANDOUTS", "₹24"],
  ["Side Staple Binding", "A4 · UP TO 40 SHEETS", "₹32"],
  ["Center Pin Binding", "A4 · FOLDED & PINNED", "₹141"],
  ["Spiral Binding", "UP TO 125 SHEETS · LIES FLAT", "₹160"],
  ["Wiro Binding", "UP TO 125 SHEETS · LAY-FLAT", "₹160"],
  ["UV Stickers / Direct Print", "WATERPROOF · PROTECTED FINISH", "on quote"],
];

export default function Pricing() {
  return (
    <section id="pricing" className="py-20 lg:py-28 bg-surface/40 border-y border-edge" data-testid="pricing-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="mb-12">
          <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-cyanbrand">
            / Pricing
          </span>
          <h2 className="mt-4 font-display font-semibold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-paper">
            Straight-up rates.
          </h2>
          <p className="mt-4 max-w-lg text-sm text-mist leading-relaxed">
            Indicative per-piece rates for A4 on 70 GSM. Colour, heavier stock, express
            jobs and bulk volumes are quoted on request — no hidden charges.
          </p>
        </Reveal>

        <div className="border-t border-edge">
          {ROWS.map(([name, spec, price], i) => (
            <motion.button
              key={name}
              data-testid={`pricing-row-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              onClick={() => scrollToId("contact")}
              className="group w-full grid grid-cols-[1fr_auto] sm:grid-cols-[1fr_1fr_auto] items-center gap-4 py-5 sm:py-6 border-b border-edge text-left hover:bg-surface2/70 transition-colors duration-300 px-2 sm:px-4"
            >
              <span className="font-display font-medium text-lg sm:text-2xl text-paper tracking-tight">
                {name}
              </span>
              <span className="hidden sm:block font-mono text-[11px] tracking-[0.2em] text-mist">
                {spec}
              </span>
              <span className="flex items-center gap-3 justify-self-end">
                <span className="font-display font-semibold text-xl sm:text-2xl text-cyanbrand">
                  {price}
                </span>
                <ArrowUpRight
                  size={18}
                  className="text-mist group-hover:text-mag group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300"
                />
              </span>
            </motion.button>
          ))}
        </div>

        <Reveal className="mt-6" delay={2}>
          <p className="font-mono text-[11px] text-mist/70 tracking-wide">
            Rates are indicative and exclusive of GST. Final quote confirmed before any job starts.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
